<template>
  <div class="dr-file-viewer-formatErr_wrapper">
      <div class="dr-file-viewer-formatErr_circle">
        <v-icon size="100" color="#848484d4">mdi-text-box</v-icon>
        <span>{{ text }}</span>
      </div>
    </div>
</template>

<script>
export default {
  props: ['text']
}
</script>

<style lang="scss">
.dr-file-viewer-formatErr_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dr-file-viewer-formatErr_circle {
    width: 250px;
    height: 250px;
    border-radius: 50%;
    background: rgb(230 230 230 / 52%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span {
      text-align: center;
      color: #9c9c9c;
      padding: 0 10px;
    }
  }
</style>